import { FC } from 'react';
import { useMount } from 'ahooks';
import { IRouteComponentProps } from 'umi';
import { useIntl } from 'react-intl';
import PageFrame from '@/components/page-frame';
import useProductList from './hooks/useProductList';
import * as SESSION_KEYS from '@/configs/session-storage-keys';

const ProductList: FC<IRouteComponentProps> = ({ match }) => {
  const { formatMessage } = useIntl();
  const { params }: any = match;
  const productType = params.type as TTypes;

  const planList = useProductList();

  const titleObj = {
    motor: formatMessage({
      id: 'Third Party Liability',
    }),
    pd: formatMessage({
      id: 'Physical Damage',
    }),
    travel: formatMessage({
      id: 'Travel',
    }),
    health: formatMessage({
      id: 'Hospital Cash',
    }),
    pa: formatMessage({
      id: 'Personal Accident',
    }),
  };

  useMount(() => {
    sessionStorage.removeItem(SESSION_KEYS.QUOTE_INFO);
    sessionStorage.removeItem(SESSION_KEYS.FIRST_STEP_INFO_FAST_QUOTE);
    sessionStorage.removeItem(SESSION_KEYS.PICKED_PLAN_INFO);
  });

  return <PageFrame title={titleObj[productType]}>{planList}</PageFrame>;
};

export default ProductList;
